import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { SafeAnchor } from '../SafeAnchor';
export const ListGroupItem = (props)=>{
    const { bsStyle, className, active, disabled, onClick, href, children } = props;
    const bsStyleClass = bsStyle ? `list-group-item-${bsStyle}` : null;
    const actionable = !!onClick || !!href;
    const Component = actionable ? SafeAnchor : 'li';
    const bsClass = classnames('list-group-item', {
        'list-group-item-action': actionable
    }, {
        active: !!active
    }, {
        disabled: !!disabled
    }, bsStyleClass, className);
    const extraProps = {};
    if (active) extraProps['aria-current'] = true;
    if (disabled) extraProps['aria-disabled'] = true;
    return /*#__PURE__*/ _jsx(Component, {
        ...extraProps,
        href: href,
        onClick: onClick,
        className: bsClass,
        children: children
    });
};
